module.exports = __webpack_public_path__ + "static/media/todolist3.6503e08e.png";